// extracted by mini-css-extract-plugin
module.exports = {"button":"BaseButton_button__tzyL8","pseudo":"BaseButton_pseudo__2cnN7"};